import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].GET_ORDER_GENERATORS_FIELDS_WORKS_SERVICES]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/services/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].GET_ORDER_GENERATORS_FIELDS_WORKS_SERVICE]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/services/:serviceId/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].CREATE_ORDER_GENERATORS_FIELDS_WORKS_SERVICE]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/services/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].PUT_ORDER_GENERATORS_FIELDS_WORKS_SERVICE]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/services/:serviceId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].PATCH_ORDER_GENERATORS_FIELDS_WORKS_SERVICE]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/services/:serviceId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES].DELETE_ORDER_GENERATORS_FIELDS_WORKS_SERVICE]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/services/:serviceId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

}